import icons from "./icons";
import { ComponentProps, FC } from "react";
import { IIcon } from "./types";
import { StaticImageData } from "next/image";

type IconProps = Omit<ComponentProps<"img">, "src"> & {
  src: StaticImageData;
};

const sizes = {
  xxxsmall: 12,
  xxsmall: 16,
  xsmall: 20,
  small: 24,
  medium: 32,
  large: 64,
  xlarge: 72,
  xxlarge: 92,
  xxxlarge: 104,
  obese: 125,
  logo: 140,
  image: 250,
};

const EMPTY_SVG = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg'/%3E`;

const Icon: FC<IIcon> = ({ name, size, wrapInSpan = false, hoverEffect = false }) => {
  const getIcon = (): IconProps | string => {
    if (Object.keys(icons).includes(name)) {
      return icons[name];
    }
    console.error(`${name} not found, using fallback`);
    return "No Icon found";
  };

  const Comp = getIcon();

  if (Comp === "No Icon found") {
    return <div>{Comp}</div>;
  }

  const { src, style } = Comp as IconProps;
  const pxSize = sizes[size || "medium"];
  const compClassName = hoverEffect ? ` hover:text-blueHighlighted` : "";

  const renderIcon = () => {
    return (
      //eslint-disable-next-line @next/next/no-img-element
      <img
        width={pxSize}
        height={pxSize}
        src={EMPTY_SVG}
        style={{
          ...style,
          backgroundColor: "currentcolor",
          mask: `url("${src}") no-repeat center / contain`,
        }}
        alt="icon"
        //{...props}
      />
    );
  };

  return wrapInSpan ? (
    <span className={`inline-block${compClassName}`}>{renderIcon()}</span>
  ) : (
    <div className={compClassName}>{renderIcon()}</div>
  );
};

export default Icon;
